import {PaneOptionCollection} from "../../lib/pane_option_collection";

// We're exporting an instance here…
export let primaryPaneOptionCollection = new PaneOptionCollection();